import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

interface SearchBarProps {
  size?: "sm" | "lg";
  placeholder?: string;
  onNavigate?: () => void;
}

export default function SearchBar({
  size = "sm",
  placeholder = "搜索影视作品、演员、类型…",
  onNavigate,
}: SearchBarProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState(searchParams.get("q") ?? "");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
    onNavigate?.();
  };

  const isLg = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center gap-2 bg-background-50 border border-background-300 rounded-full pl-4 pr-1 ${
        isLg ? "h-14 py-2" : "h-10"
      }`}
    >
      <i className="ri-search-line text-foreground-400 text-base"></i>
      <input
        type="search"
        name="keyword"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${
          isLg ? "text-base" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`rounded-full bg-accent-500 text-background-50 font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center ${
          isLg ? "h-10 px-6 text-base" : "h-8 px-4 text-sm"
        }`}
      >
        搜索
      </button>
    </form>
  );
}